import { render, staticRenderFns } from "./HostingAvailableSpaceCard.vue?vue&type=template&id=8b2caf5a&scoped=true"
import script from "./HostingAvailableSpaceCard.vue?vue&type=script&lang=js"
export * from "./HostingAvailableSpaceCard.vue?vue&type=script&lang=js"
import style0 from "./HostingAvailableSpaceCard.vue?vue&type=style&index=0&id=8b2caf5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2caf5a",
  null
  
)

export default component.exports